resourcePaths = '{"rootPath":"","assetsPath":""}';function ContentfulCacheHelper (config, params) {
  this._clientInstantiated = $.Deferred();
  this._client = null;
  this._localStore = new LocalStore('CONTENTFUL_CACHE_STORE');

  this.constructor = function (config, params) {
    if (typeof contentful === 'undefined') {
      $.ajax({
        url: 'https://cdn.jsdelivr.net/npm/contentful@latest/dist/contentful.browser.min.js',
        dataType: 'script',
        cache: true
      }).done(
        function () {
          this._initClient(config, params);
        }.bind(this)
      );
    } else {
      this._initClient(config, params);
    }
    this.syncContent();
  };

  this.syncContent = function () {
    if (this._client === null) {
      $.when(this._clientInstantiated).then(this._performSync.bind(this));
    } else {
      this._performSync();
    }
  };

  this._performSync = function () {
    if (
      _ContentfulCache.status === null
    ) {
      _ContentfulCache.status = 'syncing';
      if (
        this._localStore.store.hasOwnProperty('contentfulData')
      ) {
        // perform delta sync
        this._client.sync({nextSyncToken: this._localStore.store.contentfulData.nextSyncToken}).then(function (data) {
          for (var key in data) {
            if (Array.isArray(data[key]) && data[key].length > 0) {
              // if there is a delta change, clear the store and reload the content
              _ContentfulCache.status = null;
              delete this._localStore.store.contentfulData;
              this._performSync();
              break;
            }
          }
          _ContentfulCache.status = 'synced';
        }.bind(this));
      } else {
        // perform initial sync
        this._client.sync({initial: true}).then(function (data) {
          this._localStore.store.contentfulData = data;
          this._localStore.save();
          _ContentfulCache.status = 'synced';
        }.bind(this));
      }
    }
  };

  this._initClient = function (config, params) {
    this._client = contentful.createClient({
      // space: '0uy0bf3014cl',
      // accessToken: 'XYJlx4MqZe0TwxG_WZmAvq5aYtZpFbZ43NM4LlkOszU',
      // host: 'preview.contentful.com'
      space: params.space_id,
      accessToken: params.accessToken,
      host: config.url.replace('https://', '')
    });
    this._clientInstantiated.resolve();
  };

  this.constructor(config, params);
}